<template>
  <div>
    <router-link :to="{ name: 'details', params: { imageId: image.id } }"
                 class="item-gallery__content__list__item"
    >
      <img :src="image.src + '&size=md'"
           alt="item image"
           class="item-gallery__content__list__item__img"
      >

      <p class="item-gallery__content__list__item__badge">
        <span class="item-gallery__content__list__item__badge__year">{{ year }}</span>
      </p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "ItemGalleryListItem",
  props: {
    image: {
      type: Object,
      required: true
    }
  },
  computed: {
    year() {
      return this.image.yearOfBuild || this.image.yearOfRebuild || ''
    }
  }
}
</script>

<style lang="scss">
.item-gallery__content__list__item {
  position: relative;

  &__img {
    width: 100%;
    transition: box-shadow .3s;
  }

  &__badge {
    position: absolute;
    bottom: 4px;
    left: 0;
    display: flex;
    width: 100%;
    height: 44px;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    background-color: rgba(0, 0, 0, 0.394524);

    &__year {
      font-size: 1.5em;
      font-weight: 700;
      color: #FFFFFF;
      text-align: right;
    }

  }

  &:hover &__img {
    box-shadow: 0 2px 6px $app-box-shadow-color;
  }

}
</style>